import api from "./client";

export async function getOrderStatus(q) {
  const res = await api.get("/chatbot/order-status", { params: { q } });
  return res.data.data;
}

export async function getDailyProduction(date) {
  const res = await api.get("/chatbot/daily-production", { params: { date } });
  return res.data.data;
}

export async function getDelayedOrders() {
  const res = await api.get("/chatbot/delayed-orders");
  return res.data.data;
}

export async function getOperatorPerformance(days) {
  const res = await api.get("/chatbot/operator-performance", { params: { days } });
  return res.data.data;
}

export async function getCoilForecast(orderNo) {
  const res = await api.get("/chatbot/coil-forecast", { params: { order_no: orderNo } });
  return res.data.data;
}

export async function getStockStatus(orderNo) {
  const res = await api.get("/chatbot/stock-status", { params: { order_no: orderNo } });
  return res.data.data;
}

export async function getStockMovements({ orderNo, lotNo }) {
  const res = await api.get("/chatbot/stock-movements", {
    params: { order_no: orderNo || undefined, lot_no: lotNo || undefined },
  });
  return res.data.data;
}

export async function getCuttingTolerance({ dateFrom, dateTo }) {
  const res = await api.get("/chatbot/cutting-tolerance", {
    params: { date_from: dateFrom || undefined, date_to: dateTo || undefined },
  });
  return res.data.data;
}
